// Background for each partner resource card
export const gradientColors = [
  { start: '#0B0B0C', end: '#39271C' },
  { start: '#17161C', end: '#3A2E47' },
  { start: '#0F0F11', end: '#26282E' },
  { start: '#0B0B0C', end: '#39271C' },
  { start: '#17161C', end: '#3A2E47' },
  { start: '#0F0F11', end: '#26282E' },
];

export const EmojiFlagMap: Record<string, string> = {
  // Core
  'English': '🇺🇸',
  'Brazilian Portuguese': '🇧🇷',
  'Castilian Spanish': '🇪🇸',
  'French': '🇫🇷',
  'German': '🇩🇪',
  'Hindi': '🇮🇳',
  'Italian': '🇮🇹',
  'Japanese': '🇯🇵',
  'Korean': '🇰🇷',
  'Latin American Spanish': '🇲🇽',
  'Chinese': '🇨🇳',
  'Russian': '🇷🇺',
  'Arabic': '🇸🇦',
  'Dutch': '🇳🇱',

  // English variants
  'English (US)': '🇺🇸',
  'English (UK)': '🇬🇧',
  'English (Canada)': '🇨🇦',
  'English (Australia)': '🇦🇺',
  'English (India)': '🇮🇳',

  // Spanish variants
  'Spanish': '🇪🇸',
  'Spanish (Spain)': '🇪🇸',
  'Spanish (Mexico)': '🇲🇽',
  'Spanish (Argentina)': '🇦🇷',
  'Spanish (Colombia)': '🇨🇴',
  'Spanish (Chile)': '🇨🇱',
  'Spanish (Peru)': '🇵🇪',

  // Portuguese variants
  'Portuguese': '🇵🇹',
  'Portuguese (Portugal)': '🇵🇹',

  // Chinese variants
  'Simplified Chinese': '🇨🇳',
  'Traditional Chinese': '🇹🇼',
  'Chinese (Hong Kong)': '🇭🇰',

  // European languages
  'Swedish': '🇸🇪',
  'Norwegian': '🇳🇴',
  'Danish': '🇩🇰',
  'Finnish': '🇫🇮',
  'Polish': '🇵🇱',
  'Czech': '🇨🇿',
  'Hungarian': '🇭🇺',
  'Romanian': '🇷🇴',
  'Greek': '🇬🇷',
  'Turkish': '🇹🇷',
  'Ukrainian': '🇺🇦',

  // Asian languages
  'Bengali': '🇧🇩',
  'Urdu': '🇵🇰',
  'Tamil': '🇮🇳',
  'Telugu': '🇮🇳',
  'Vietnamese': '🇻🇳',
  'Thai': '🇹🇭',
  'Indonesian': '🇮🇩',
  'Malay': '🇲🇾',
  'Filipino': '🇵🇭',

  // Middle East/Africa
  'Hebrew': '🇮🇱',
  'Persian': '🇮🇷',
  'Swahili': '🇰🇪',
  'Afrikaans': '🇿🇦',

  // Additional
  'Catalan': '🇪🇸',
  'Slovak': '🇸🇰',
  'Bulgarian': '🇧🇬',
  'Croatian': '🇭🇷',
  'Serbian': '🇷🇸',
  'Lithuanian': '🇱🇹',
  'Latvian': '🇱🇻',
  'Estonian': '🇪🇪',
};

export const ReactWorldFlagsMap = {
  'English': {
    code: 'US',
    nativeName: 'English',
    displayName: 'English',
  },
  'Brazilian Portuguese': {
    code: 'BR',
    nativeName: 'Português (Brasil)',
    displayName: 'Portuguese - Brazilian (Português Brasileiro)',
  },
  'Castilian Spanish': {
    code: 'ES',
    nativeName: 'Español (Castellano)',
    displayName: 'Spanish - Castilian (Español Castellano)',
  },
  'French': {
    code: 'FR',
    nativeName: 'Français',
    displayName: 'French (Français)',
  },
  'German': {
    code: 'DE',
    nativeName: 'Deutsch',
    displayName: 'German (Deutsch)',
  },
  'Hindi': {
    code: 'IN',
    nativeName: 'हिन्दी (Hindi)',
    displayName: 'Hindi (हिन्दी)',
  },
  'Italian': {
    code: 'IT',
    nativeName: 'Italiano',
    displayName: 'Italian (Italiano)',
  },
  'Japanese': {
    code: 'JP',
    nativeName: '日本語 (Nihongo)',
    displayName: 'Japanese (日本語 Nihongo)',
  },
  'Korean': {
    code: 'KR',
    nativeName: '한국어 (Hanguk-eo)',
    displayName: 'Korean (한국어 Hanguk-eo)',
  },
  'Latin American Spanish': {
    code: 'MX',
    nativeName: 'Español (América Latina)',
    displayName: 'Spanish - Latin American (Español América Latina)',
  },
  'Chinese': {
    code: 'CN',
    nativeName: '中文 (Zhōngwén)',
    displayName: 'Chinese (中文 Zhōngwén)',
  },
  'Russian': {
    code: 'RU',
    nativeName: 'Русский (Russkiy)',
    displayName: 'Russian (Русский Russkiy)',
  },
  'Arabic': {
    code: 'SA',
    nativeName: 'العربية (Al-‘Arabiyya)',
    displayName: 'Arabic (العربية Al-‘Arabiyya)',
  },
  'Dutch': {
    code: 'NL',
    nativeName: 'Nederlands',
    displayName: 'Dutch (Nederlands)',
  },
};

export type EmojiFlagMapType = keyof typeof EmojiFlagMap;